export default __webpack_public_path__ + "static/media/31_TopRightSquares_Bottom.7e0f7fbc.mp4";